import React from 'react';
import '../CSS/App.css';
import '../CSS/Main.css'

const Main = () => {
    return (
      <div>
        <p className="title">Jeremy                         Cabrera</p>
        <p>Welcome to my portfolio website! Created by me using React and hosted on my very own webserver. I hope you enjoy your stay</p>
      </div>
    );
};

export default Main;
